import React from "react";
import t from '../../../helpers/t';
import {_} from "../../../../../vendor";
import SubChanges from "./SubChanges";

const Changes = (props) => {
    let setted = "";
    return (
        <>
          {props.changes !== null &&
          <>
              {Object.keys(props.changes).map((itemKey) => {
                      return(
                              <>
                                  {setted === "" &&
                                  <p style={{fontWeight:"bold"}}>{itemKey}:</p>
                                  }
                                  {setted !== "" &&
                                  <>
                                      <p>&nbsp;</p>
                                      <p style={{fontWeight:"bold"}}>{itemKey}:</p>
                                      </>
                                  }

                                  {setted = props.changes[itemKey] &&
                                      <SubChanges
                                         subChanges={props.changes[itemKey]}
                                      />
                                  }
                              </>
                      );
              })}
          </>
          }
    </>
  );
};

export default Changes;